import { IRestaurantsState } from './restaurantsContext';
import { EntityStatus } from 'types';
import { RestaurantsActionTypes, TRestaurantsAction } from './restaurantsActions';

export const restaurantsReducer = (state: IRestaurantsState, action: TRestaurantsAction): IRestaurantsState => {
	switch (action.type) {
		case RestaurantsActionTypes.SET_RESTAURANTS:
			return {
				...state,
				restaurants: action.payload.restaurants,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case RestaurantsActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case RestaurantsActionTypes.SET_ID_SELECTED_COUNTRY:
			return {
				...state,
				IDSelectedCountry: action.payload.IDSelectedCountry,
				IDSelectedCity: null,
				IDSelectedCustomer: null,
				currentPage: 1,
			};
		case RestaurantsActionTypes.SET_ID_SELECTED_CITY:
			return {
				...state,
				IDSelectedCity: action.payload.IDSelectedCity,
				IDSelectedCustomer: null,
				currentPage: 1,
			};
		case RestaurantsActionTypes.SET_ID_SELECTED_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				currentPage: 1,
			};
		case RestaurantsActionTypes.SET_IDs_CLIENT_TYPE:
			return {
				...state,
				IDsSelectedClientType: action.payload.IDsSelectedClientType,
				currentPage: 1,
			};
		case RestaurantsActionTypes.SET_STATUS:
			return {
				...state,
				status: action.payload.status,
				restaurants: { restaurantCount: 0, restaurants: [] },
				currentPage: 1,
			};
		case RestaurantsActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedCountry: null,
				IDSelectedCity: null,
				IDSelectedCustomer: null,
				IDsSelectedClientType: [],
				status: EntityStatus.Active,
				currentPage: 1,
			};
		case RestaurantsActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case RestaurantsActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case RestaurantsActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case RestaurantsActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case RestaurantsActionTypes.SET_ID_FOR_ARCHIVING:
			return {
				...state,
				IDForArchiving: action.payload.IDForArchiving,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case RestaurantsActionTypes.SET_ID_FOR_RESTORING:
			return {
				...state,
				IDForRestoring: action.payload.IDForRestoring,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case RestaurantsActionTypes.SET_FULL_INFO_DATA:
			return {
				...state,
				fullInfoData: {
					id: action.payload.fullInfoData?.id,
					activeTab: action.payload.fullInfoData?.activeTab,
				},
			};
		case RestaurantsActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case RestaurantsActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
			};
		default:
			return state;
	}
};
